/**
 * Greeting A/B API Service (KAN-647)
 *
 *   GET /api/v1/telegram/greeting-ab/?operator_id= - статистика вариантов первого сообщения
 *   (KAN-752: с operator_id - только рассылка этого оператора)
 */
import apiClient from './client';

/** Строка таблицы A/B: вариант шаблона первого сообщения и его счётчики. */
export interface GreetingVariantStats {
  variant_id: string;
  text: string;
  preview: string;
  /** current: вариант есть в шаблонах; removed: вариант удалён; unknown: не определён. */
  status: 'current' | 'removed' | 'unknown';
  sent: number;
  replied: number;
  reply_rate: number | null;
  ci_low: number | null;
  ci_high: number | null;
  interested: number;
  lost: number;
  low_data: boolean;
  /** KAN-651: template - шаблон кабинета, brief - вариант-бриф с пулом текстов. */
  kind?: 'template' | 'brief';
  /** KAN-651: буква варианта-брифа. */
  label?: string;
}

export interface GreetingAbData {
  variants: GreetingVariantStats[];
  low_data_threshold: number;
}

export const greetingAbApi = {
  get: async (operatorId?: string): Promise<GreetingAbData> => {
    const response = await apiClient.get('/api/v1/telegram/greeting-ab/', {
      params: operatorId ? { operator_id: operatorId } : undefined,
    });
    return response.data;
  },
};

export default greetingAbApi;
